import { Button, Col, Container, Row } from "react-bootstrap";
import Poster from "../../image/healthPoster.png";
import Doc from "../../docs/Healthcare.pdf";

export default function EitecHealth() {
    return <>
    <Container fluid>
        <Container>
            <br/>
            <img src={Poster} width="100%"/>
            <br/><br/>
            <Row className="justify-content-center">
                    <Col md="auto" sm="12">
                        <Button href={Doc} target="_blank">Read Brochure <i className="bi bi-arrow-right"></i></Button>
                    </Col>
            </Row>
            <br/><br/>

        </Container>
    </Container>
    </>
}